/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DynamoDbBillingMode } from '../models/DynamoDbBillingMode';

export class AwsDynamoDbResource {
  'billingMode': DynamoDbBillingMode;
  'readCapacityUnits': number;
  'writeCapacityUnits': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "billingMode",
      "baseName": "billingMode",
      "type": "DynamoDbBillingMode",
      "format": ""
    },
    {
      "name": "readCapacityUnits",
      "baseName": "readCapacityUnits",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "writeCapacityUnits",
      "baseName": "writeCapacityUnits",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return AwsDynamoDbResource.attributeTypeMap;
  }

  public constructor() {
  }
}



